import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { PhxTabComponent } from './phx-tab.component';
import { PhxTabsetType } from './phx-tabset.type';

@Injectable()
export class TabsetService {
  private _tabChangedSubject: BehaviorSubject<PhxTabComponent> = new BehaviorSubject<PhxTabComponent>(null);
  public tabChanged$: Observable<PhxTabComponent> = this._tabChangedSubject.asObservable();

  private _changeIndicatorPositionSubject: BehaviorSubject<void> = new BehaviorSubject<void>(null);
  public changeIndicatorPosition$: Observable<void> = this._changeIndicatorPositionSubject.asObservable();

  private _tabTypeSubject: BehaviorSubject<PhxTabsetType> = new BehaviorSubject<PhxTabsetType>(null);
  public tabTypeChanged$: Observable<PhxTabsetType> = this._tabTypeSubject.asObservable();

  public phxMatchUrl: boolean = false;
  public phxShouldMatchExactLink: boolean = false;

  public onTabChanged(tab: PhxTabComponent): void {
    this._tabChangedSubject.next(tab);
  }

  public onTabTypeChanged(type: PhxTabsetType): void {
    this._tabTypeSubject.next(type);
  }

  public onChangeIndicatorPosition(): void {
    this._changeIndicatorPositionSubject.next();
  }
}
